import ExchangeList from '@/views/webpc/CreditMall/ExchangeListApp/ExchangeList'

// 定义路由路径数列表
export default [{
  path: '/exchangeList',
  name: '兑换记录 ',
  component: ExchangeList
}]



// WEBPACK FOOTER //
// ./src/views/webpc/CreditMall/ExchangeListApp/routers/index.js